export const inputConstraints = {
  positive: true,
  noExponent: true,
  maxInputLength: 7,
  isOnlyIntegers: true,
  shouldFormatValue: false,
};
